import { render, staticRenderFns } from "./EatIconList.vue?vue&type=template&id=70f02cbc"
import script from "./EatIconList.vue?vue&type=script&lang=js"
export * from "./EatIconList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports